export const theme = {
  color: {
    buttonBackground: "hsl(39, 51%, 68%)",
    text: "hsl(0, 20%, 30%)",
    tableBackground: "hsl(197, 100%, 99%)",
    tableHeader: "hsl(0, 20%, 79%)",
    tableRow: "hsl(0, 24%, 94%)",
    rowHover: "hsl(0, 21%, 89%)",
    cellBorder: "hsl(0, 0%, 67%)",
    converterBackground: "hsl(37, 74%, 90%)",
    legendBackground: "hsl(39, 51%, 68%)",
    borderColor: "hsla(0, 0%, 80%)",
    footerBackground: "hsl(37, 74%, 90%)",
    footerLink: "hsl(182, 25%, 50%)",
    white: "hsl(0, 0%, 100%)",
    errorRed: "hsla(1, 77%, 55%)",
  },

  breakpoint: {
    mobileMax: "848px",
  },
};
